import React, { useContext } from 'react';
import { Anchor, Flex, Image, Notification, Text } from '@mantine/core';
import { HeadquarterContext } from 'context/HeadquarterContext';

import { LEGACY_DASHBOARD_URL } from 'constants/chownow';
import { LOCATION_PATH } from 'constants/path';

import HalftoneFlag from 'assets/images/halftone-flag.png';

import { ArrowRightIconSm } from '@chownow/pantry/icons';
export default function OnboardingBanner() {
  const { location } = useContext(HeadquarterContext);
  const isRestaurantLevel = window.location.pathname.includes(LOCATION_PATH);

  // self-serve restaurants onboard in the wizard, not the legacy checklist
  if (!isRestaurantLevel || !location || location.onboarding_flow === 'self_guided') {
    return null;
  }

  const onboardingPath = `${LEGACY_DASHBOARD_URL}/restaurant/${location.id}/onboarding`;

  return (
    <Anchor href={onboardingPath} underline="never" target="_blank" mt="md">
      <Notification
        icon={<Image src={HalftoneFlag} alt="flag" w={40} h={40} />}
        bg="var(--surface-paper-1)"
      >
        <Flex align="center" justify="space-between" my="xs2">
          <Text lh="var(--mantine-line-height-md)">
            We&apos;re missing information that&apos;s required to launch on ChowNow. See
            what&apos;s left on your checklist.
          </Text>
          <ArrowRightIconSm style={{ flexShrink: 0 }} />
        </Flex>
      </Notification>
    </Anchor>
  );
}
